import { Box, Divider, Grid, Typography } from "@material-ui/core"
import { isEmpty, isEqual } from "lodash"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { DialogQRCodeEntrega } from "../../../../../components/dialog/dialog-qr-code-entrega/dialog-qr-code-entrega"
import { ProcessoProdutoSetorModel } from "../../../../../../model/api/processo-produto-setor/processo-produto-setor-model"
import { KdsStorageKeys, useKdsStorage, useSessaoAtual, useToastSaurus } from "../../../../../../services/app"
import { useImpressao } from "../../../../../../hooks/impressao"
import { useThemeQueries } from "../../../../../theme"
import { CircularLoading } from "../../../../../components"
import { EnumStatusPedido } from "../../../../../../model/enums/enum-status-pedido"
import { useHistory } from "react-router-dom"
import { useStyles } from "./monitoramento-setores-list-styles"
import { ProcessoSetorModel } from "../../../../../../model/api/processo-setor/processo-setor-model"
import { useGetProcessoProdutoSetor } from "../../../../../../data/api/gestao/processo-produto-setor/get-processo-produto-setor"
import { useGetPedido } from "../../../../../../data/api/gestao/pedido/get-pedido"
import { usePutAlterarProcesso } from "../../../../../../data/api/gestao/processo-produto-setor/put-processo-produto-setor"
import { PedidoModel } from "../../../../../../model/api/pedidos/pedido-model"
import { AdicionarRemoverProcessos } from "../../../../../../model/app/forms/adicionar-remover-processos/adicionar-remover-processos"
import { ProcessoProdutoSetorModelNovo } from "../../../../../../model/api/processo-produto-setor/put-processo-produto-setor"
import { VariaveisAmbiente } from "../../../../../../config"
import { EnumDeviceType } from "../../../../../../model/enums/enum-device-type"
import { MonitoramentoSetoresProcessosList } from "../monitoramento-setores-processos-list/monitoramento-setores-processos-list"
import { useConfigGeraisStore } from "../../../../../../services/app/stores/config-gerais"
import { numberToGridSize } from "../../../../../../utils/number-to-grid-size"
import { useEmpresaAtual } from "../../../../../../services/app/use-cases/empresa-atual"
import { EnumEmpresaConfig } from "../../../../../../model/enums/enum-empresa-config"
import countingMachineSound from "../../../../../../assets/sounds/counting_machine_1.mp3"
import { useGetProcessoSetor } from "../../../../../../data/api/gestao/processo-setor/get-processo-setor"
import { useConfirm } from "material-ui-confirm"
import { sincronizarProcessosSetoresStorage } from "../../../../../../utils/sincronizar-processos-setores-storage"

export const MonitoramentoSetoresList = () => {
    const eventoAtualizacaoSetores = "kds-processos-setores-updated"

    //AUX
    const history = useHistory()
    const { showToast } = useToastSaurus()
    const classes = useStyles();
    const { theme } = useThemeQueries();
    const { imprimir } = useImpressao()
    const confirm = useConfirm()

    //PROVIDERS
    const { getRegistro, setRegistro } = useKdsStorage()
    const { getEmpresaSelecionada } = useSessaoAtual()
    const { getConfigByCod } = useEmpresaAtual()
    const [setoresStorageState, setSetoresStorageState] = useState<ProcessoSetorModel[]>(
        () => (getRegistro(KdsStorageKeys.ProcessosSetores, false) as ProcessoSetorModel[]) ?? [],
    )

    const configIntervaloAtualizacao = getConfigByCod(EnumEmpresaConfig.IntervaloAtualizacaoMonitoramento) ?? '20';
    const intervaloAtualizacao = configIntervaloAtualizacao ? Number(configIntervaloAtualizacao) * 1000 : 20000

    //CHAMADAS API
    const { getProcessoProdutoSetor, carregando: carregandoProduto } = useGetProcessoProdutoSetor()
    const { getProcessoSetor } = useGetProcessoSetor()
    const { getPedido, carregando: carregandoPedido } = useGetPedido();
    const { putAlterarProcesso, carregando: carregandoPutProcesso } = usePutAlterarProcesso()

    const carregando = carregandoPedido || carregandoProduto || carregandoPutProcesso;

    const produtosDistintosRef = useRef<ProcessoProdutoSetorModel[]>([]);
    const produtosNaoImpressosRef = useRef<ProcessoProdutoSetorModel[]>([]);
    const interval = useRef<NodeJS.Timer>();
    const audioIntervalRef = useRef<NodeJS.Timer>();
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const audioTocandoRef = useRef<boolean>(false);
    const pedidosProcessoZeroRef = useRef<Set<number | string>>(new Set());
    const carregouRef = useRef<boolean>(false)
    const validouStorageRef = useRef<boolean>(false)

    const handleClose = useCallback(() => {
        setAbrirQrCode(false);
        setProcessosSelecionados([]);
    }, [])

    const setores: ProcessoSetorModel[] = useMemo(
        () => isEmpty(setoresStorageState) ? [] : setoresStorageState,
        [setoresStorageState],
    )

    const exibirAvisoSincronizacao = useCallback((detalhes: {
        setoresRemovidos: number;
        processosRemovidos: number;
        setoresAtualizados: number;
        processosAtualizados: number;
    }) => {
        const mensagens: string[] = []
        if (detalhes.setoresRemovidos > 0) mensagens.push(`${detalhes.setoresRemovidos} setor(es) removido(s)`)
        if (detalhes.processosRemovidos > 0) mensagens.push(`${detalhes.processosRemovidos} processo(s) removido(s)`)
        if (detalhes.setoresAtualizados > 0) mensagens.push(`${detalhes.setoresAtualizados} setor(es) atualizado(s)`)
        if (detalhes.processosAtualizados > 0) mensagens.push(`${detalhes.processosAtualizados} processo(s) atualizado(s)`)

        confirm({
            title: "Setores e processos atualizados",
            description: `Detectamos alterações na retaguarda e atualizamos automaticamente sua configuração local.${mensagens.length ? `\n\nResumo: ${mensagens.join(", ")}.` : ""}`,
            cancellationText: "Fechar",
            cancellationButtonProps: { color: "default", variant: "contained" },
            confirmationText: "Entendi",
        }).catch(() => undefined)
    }, [confirm])

    useEffect(() => {
        if (isEmpty(setores)) {
            history.push('/selecionar-setor')
            showToast('info', 'Selecione os setores para visualizar a página.')
        }
    }, [history, setores, showToast])

    const carregarSetoresStorage = useCallback(() => {
        const setoresStorage = (getRegistro(KdsStorageKeys.ProcessosSetores, false) as ProcessoSetorModel[]) ?? []
        setSetoresStorageState(setoresStorage)
    }, [getRegistro])

    useEffect(() => {
        const atualizarSetores = () => carregarSetoresStorage()
        window.addEventListener(eventoAtualizacaoSetores, atualizarSetores)
        window.addEventListener('storage', atualizarSetores)

        return () => {
            window.removeEventListener(eventoAtualizacaoSetores, atualizarSetores)
            window.removeEventListener('storage', atualizarSetores)
        }
    }, [carregarSetoresStorage, eventoAtualizacaoSetores])

    useEffect(() => {
        if (validouStorageRef.current) return
        validouStorageRef.current = true

        const validarSetoresStorage = async () => {
            try {
                const registroStorage = (getRegistro(KdsStorageKeys.ProcessosSetores, false) as ProcessoSetorModel[]) ?? []
                if (isEmpty(registroStorage)) return

                const res = await getProcessoSetor(getEmpresaSelecionada()?.Id ?? '')
                if (res.erro) throw res.erro

                const setoresRetaguarda = (res.resultado?.data.list ?? []) as ProcessoSetorModel[]
                if (isEmpty(setoresRetaguarda)) return

                const sincronizacao = sincronizarProcessosSetoresStorage(registroStorage, setoresRetaguarda)
                if (!sincronizacao.teveAlteracao) {
                    setSetoresStorageState(registroStorage)
                    return
                }

                setRegistro(KdsStorageKeys.ProcessosSetores, sincronizacao.processosSetores, false)
                setSetoresStorageState(sincronizacao.processosSetores)
                exibirAvisoSincronizacao(sincronizacao)
            } catch (e: any) {
                showToast('error', e.message)
            }
        }

        validarSetoresStorage()
    }, [exibirAvisoSincronizacao, getEmpresaSelecionada, getProcessoSetor, getRegistro, setRegistro, showToast])

    //STATES E REFS
    const [pedidos, setPedidos] = useState<PedidoModel[]>([]);
    const [produtos, setProdutos] = useState<Array<ProcessoProdutoSetorModel>>([])
    const [abrirQrCode, setAbrirQrCode] = useState<boolean>(false);
    const [processosSelecionados, setProcessosSelecionados] = useState<AdicionarRemoverProcessos[]>([]);
    const habilitarAudioPedidoNovo = useConfigGeraisStore(state => state.config.habilitarAudioPedidoNovo ?? true)
    const intervaloAudioPedidoNovoMs = useConfigGeraisStore(state => state.config.intervaloAudioPedidoNovoMs ?? 15000)

    const tocarAudioPedidoNovo = useCallback(async () => {
        if (!habilitarAudioPedidoNovo || audioTocandoRef.current) return

        try {
            if (!audioRef.current) {
                audioRef.current = new Audio(countingMachineSound)
                audioRef.current.preload = 'auto'
            }

            audioTocandoRef.current = true
            audioRef.current.currentTime = 0
            await audioRef.current.play()
        } catch (e) {
            // Ignore playback lock failures (browser policy).
        } finally {
            window.setTimeout(() => {
                audioTocandoRef.current = false
            }, 1200)
        }
    }, [habilitarAudioPedidoNovo])

    const limparIntervaloAudio = useCallback(() => {
        clearInterval(audioIntervalRef.current)
        audioIntervalRef.current = undefined
    }, [])

    const iniciarIntervaloAudio = useCallback(() => {
        limparIntervaloAudio()
        audioIntervalRef.current = setInterval(() => {
            if (pedidosProcessoZeroRef.current.size > 0) {
                tocarAudioPedidoNovo()
                return
            }

            limparIntervaloAudio()
        }, intervaloAudioPedidoNovoMs)
    }, [intervaloAudioPedidoNovoMs, limparIntervaloAudio, tocarAudioPedidoNovo])

    const avaliarAudioPedidosNovos = useCallback((produtosAtuais: ProcessoProdutoSetorModel[]) => {
        if (!habilitarAudioPedidoNovo) {
            pedidosProcessoZeroRef.current = new Set()
            limparIntervaloAudio()
            return
        }

        const pedidosProcessoZero = new Set<number | string>(
            produtosAtuais
                .filter(produto =>
                    produto.processoProducaoAtual === 0 &&
                    produto.status?.codigo !== EnumStatusPedido.Cancelado,
                )
                .map(produto => produto.pedidoId),
        )

        const possuiPedidosProcessoZero = pedidosProcessoZero.size > 0
        const temNovoPedido = Array.from(pedidosProcessoZero).some(pedidoId => !pedidosProcessoZeroRef.current.has(pedidoId))

        pedidosProcessoZeroRef.current = pedidosProcessoZero

        if (temNovoPedido) {
            tocarAudioPedidoNovo()
            iniciarIntervaloAudio()
        }

        if (!possuiPedidosProcessoZero) {
            limparIntervaloAudio()
            return
        }

        if (!audioIntervalRef.current) {
            iniciarIntervaloAudio()
        }
    }, [habilitarAudioPedidoNovo, iniciarIntervaloAudio, limparIntervaloAudio, tocarAudioPedidoNovo])

    const getPedidosWrapper = useCallback(async () => {
        try {
            const res = await getPedido(getEmpresaSelecionada()?.Id!, `?tipoPedido=0,1`);

            if (res.erro) throw res.erro;

            return setPedidos(res.resultado?.data.list)
        } catch (e: any) {

        }
    }, [getEmpresaSelecionada, getPedido])

    const getProcessoProdutoSetorWrapper = useCallback(async () => {
        try {
            // setores.map(item => item.processos).reduce((arr, obj) => arr.concat(obj), []).map(x => x.id).toString().replaceAll(',', ';')
            const query = setores.map(item => item.processos.filter(item => item.processoProducao < 9000).map(item => `${item.id};`).toString().replaceAll(',', ''))
            const saloes = setores.filter(x => !isEmpty(x.salao)).map(item => (`${item.salao.id};`).toString().replaceAll(',', ''));
            const queryString = ('&processosIds=' + query.map(item => item).toString().replaceAll(',', '')) +
                (!isEmpty(saloes) ? ('&salaoId=' + saloes.map(item => item).toString().replaceAll(',', '')) : '');

            const res = await getProcessoProdutoSetor(getEmpresaSelecionada()?.Id ?? '', queryString + '&pageSize=10000')

            if (res.erro) throw res.erro

            const produtos = res.resultado?.data.list as ProcessoProdutoSetorModel[]
            setProdutos(produtos);
            avaliarAudioPedidosNovos(produtos)

            produtosDistintosRef.current = produtos.reduce<ProcessoProdutoSetorModel[]>((prev, curr) => {
                if (prev.some((y) => y.pedidoId === curr.pedidoId)) return [...prev]
                return [...prev, curr];
            }, [])
            produtosNaoImpressosRef.current = produtosDistintosRef.current.filter(x => !x.produtoImpresso)

            return
        } catch (e: any) {
            showToast('error', e.message)
        }
    }, [avaliarAudioPedidosNovos, getEmpresaSelecionada, getProcessoProdutoSetor, setores, showToast])

    const putProcessosWrapper = useCallback(async (produtos: ProcessoProdutoSetorModel[], produtoAtual: ProcessoProdutoSetorModel) => {
        try {
            const ids = produtos.map(x => x.id)
            const novoModelo = new ProcessoProdutoSetorModelNovo(ids, true)
            let ret: any = ''
            ret = await putAlterarProcesso(novoModelo, getEmpresaSelecionada()?.Id || '', produtoAtual.processoProducaoAtual)
            if (ret.erro) {
                throw ret.erro
            }
        } catch (e: any) { }
    }
        , [getEmpresaSelecionada, putAlterarProcesso])

    const printType = useCallback((): 'HTML' | 'NATIVE' => {
        switch (VariaveisAmbiente.paymentDevice) {
            case EnumDeviceType.NAVIGATOR:
                return 'HTML';
            case EnumDeviceType.CORDOVA:
                return 'NATIVE';
            default: return 'HTML'
        }
    }, []);

    const imprimirNativo = useCallback(async () => {
        try {
            if (produtosNaoImpressosRef.current.length > 0
                && printType() === 'NATIVE'
            ) {
                for (const produto of produtosNaoImpressosRef.current) {
                    if (!produto.produtoImpresso && !isEmpty(produto.impressoes)) {
                        for (const impressao of produto.impressoes) {
                            if (isEmpty(impressao.equipamento)) continue
                            await putProcessosWrapper(produtosDistintosRef.current, produto)
                            await imprimir(
                                impressao.equipamento.colunas,
                                impressao.impressao,
                                `${impressao.equipamento.caminho}${impressao.equipamento.usuario ? `|${impressao.equipamento.usuario}` : ''}${impressao.equipamento.senha ? `|${impressao.equipamento.senha}` : ''}`,
                                impressao.equipamento.modelo,
                                impressao.equipamento.quantidadeVias
                            )
                        }
                    }
                }
            }
        } catch (e: any) {
            console.log(e)
            showToast('error', e.message)
        }
    }, [imprimir, printType, putProcessosWrapper, showToast])

    const verificarPedidos = useCallback(async () => {
        const asyncInterval = async () => {
            await getProcessoProdutoSetorWrapper()
            await getPedidosWrapper();
            if (produtosNaoImpressosRef.current.length > 0 && printType() === 'NATIVE') {
                await imprimirNativo()
            }
        }
        asyncInterval();
        clearInterval(interval.current);
        interval.current = setInterval(() => {
            asyncInterval();
        }, intervaloAtualizacao);
    }, [getPedidosWrapper, getProcessoProdutoSetorWrapper, imprimirNativo, intervaloAtualizacao, printType])

    useEffect(() => {
        if (!carregouRef.current) {
            verificarPedidos();
        }

        carregouRef.current = true

        window.addEventListener('popstate', () => {
            clearInterval(interval.current);
        })
    }, [getPedidosWrapper, getProcessoProdutoSetorWrapper, imprimirNativo, produtosNaoImpressosRef.current.length, verificarPedidos])

    useEffect(() => {
        return () => clearInterval(interval.current);
    }, [])

    useEffect(() => {
        limparIntervaloAudio()
        if (pedidosProcessoZeroRef.current.size > 0 && habilitarAudioPedidoNovo) {
            tocarAudioPedidoNovo()
            iniciarIntervaloAudio()
        }
    }, [habilitarAudioPedidoNovo, iniciarIntervaloAudio, limparIntervaloAudio, tocarAudioPedidoNovo])

    useEffect(() => {
        return () => {
            limparIntervaloAudio()
            if (audioRef.current) {
                audioRef.current.pause()
                audioRef.current.currentTime = 0
            }
        }
    }, [limparIntervaloAudio])

    const getProcessosEImpressao = useCallback(async () => {
        try {
            await getProcessoProdutoSetorWrapper()
            await imprimirNativo()
        } catch (e: any) {
            console.log(e)
            showToast('error', e.message)
        }
    }, [getProcessoProdutoSetorWrapper, imprimirNativo, showToast])

    const qtdeSetores = useConfigGeraisStore(state => state.config.qtdeSetores)

    return (
        <>
            {carregando && (
                <div className={classes.loading}>
                    <CircularLoading tipo="FULLSIZED" />
                </div>
            )}
            <Box p={2}>
                <Grid container spacing={2}>
                    {setores
                        .map((setor) => {
                            const produtosSetor = produtos.filter(produto => {
                                const prods = setores.filter(x => x.setor.id === produto.setorId)
                                return (produto?.setorId === setor?.setor.id) &&
                                    produto.status.codigo !== EnumStatusPedido.Cancelado &&
                                    (setor.salao ? isEqual(produto.salaoId, setor.salao?.id) : prods)
                            }
                            )
                            // Definir tamanho do grid de acordo com a quantidade de setores setados no localStorage 
                            const diffConcluidosCancelados = setor?.processos.filter(item => (item.processoProducao < 9000))
                            return (
                                <Grid item xs={numberToGridSize(qtdeSetores)} key={setor.setor.id}>
                                    <Grid item xs={12} className={classes.setorTitle} >
                                        {/* <img src={setor.setor?.uriImage} alt="" /> */}
                                        <Typography className={classes.title}>
                                            {setor?.setor.descricao}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{
                                                paddingLeft: '8px',
                                            }}
                                        >
                                            {!isEmpty(setor?.salao?.descricao) ? `(${setor?.salao?.descricao})` : '(Sem Salão Cadastrado)'}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Divider variant="fullWidth" style={{ background: theme.palette.grey[400] }} />
                                    </Grid>

                                    <Grid item xs={12} >
                                        <Grid container spacing={2} style={{ padding: '16px 0px' }}>
                                            <MonitoramentoSetoresProcessosList
                                                pedidos={pedidos}
                                                getProcessoProdutoSetorWrapper={getProcessosEImpressao}
                                                processos={diffConcluidosCancelados}
                                                produtosSetor={produtosSetor}
                                                setAbrirQrCode={setAbrirQrCode}
                                                processosSelecionados={processosSelecionados}
                                                setProcessosSelecionados={setProcessosSelecionados}
                                                setores={setores}
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                            )
                        })}
                </Grid>
            </Box>
            <DialogQRCodeEntrega
                open={abrirQrCode}
                carregando={carregando}
                model={processosSelecionados}
                handleClose={handleClose}
                processos={produtos}
            />
        </>
    )
}